import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Bill } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EditableCellContent } from "@design-system/ViewTable/EditableCellContent";
import { Amount } from "@design-system/Amount/Amount";
import { useAccrualAwareTableMeta } from "@hooks/view/accrualAwareTableMeta";
import { getBillOpenAmount } from "@common/helpers/accrual/openAmount";
import { BillsViewCallbacks } from "../types";

export const OpenAmountCell = memo(
    ({ row, table }: CellContext<ViewTableFeatures, Bill, number>) => {
        const bill = row.original;
        const { callbacks, accrualEntityIds, isLoadingAccrualLedgers } =
            useAccrualAwareTableMeta<BillsViewCallbacks, Bill>(table);

        return (
            <ViewTableCell captureClicks>
                <EditableCellContent
                    onClick={() => callbacks?.onBillClick?.(bill)}
                    readonly
                >
                    {isLoadingAccrualLedgers ? (
                        "-"
                    ) : (
                        <Amount
                            amount={getBillOpenAmount(bill, accrualEntityIds)}
                        />
                    )}
                </EditableCellContent>
            </ViewTableCell>
        );
    },
);
